<div class="container-fluid psp-container">
  <div class="card mb-4">
    <div class="row align-items-center pt-3">
      <div class="col-lg-6 col-7">
        <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-3">
          <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
            <li class="breadcrumb-item text-primary psp-breadcrumb">
              <a class="text-primary" [routerLink]="'/psp/daily-tasks'">
                Daily Tasks
              </a>
            </li>

            <li
              aria-current="page"
              class="breadcrumb-item active text-gray psp-breadcrumb"
            >
              Pending Patient
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="card-body">
      <form #carReceiveForm="ngForm">
        <h2>Personal Details</h2>

        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="full-name">
                Full Name
              </label>

              <input
                [value]="task?.patient.name"
                class="form-control"
                id="full-name"
                placeholder="Full Name"
                disabled
                type="text"
                name="patientName"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="program-name">
                Program Name
              </label>
              <input
                [value]="task?.program.name"
                class="form-control"
                id="program-name"
                placeholder="Program Name"
                disabled
                type="text"
              />

              <!-- <select class=" form-control"
                                id="programName" (change)="routeChanged($event.target.value)">
                                <option *ngFor="let route of routes" [value]="route.id"> {{route.pageName}} </option>
                            </select> -->
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="patient-nationalId">
                National ID
              </label>
              <div class="button-in">
                <input
                  [value]="task?.patient?.nationalId"
                  class="form-control"
                  id="patient-nationalId"
                  placeholder="National ID"
                  disabled
                  type="text"
                />
                <button *ngIf="task?.nationalIdPaths?.length > 0" class="btn btn-primary btn-sm"
                  (click)="downloadNationalIds()">Download</button>
              </div>

              <!-- <select class=" form-control"
                                id="programName" (change)="routeChanged($event.target.value)">
                                <option *ngFor="let route of routes" [value]="route.id"> {{route.pageName}} </option>
                            </select> -->
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="example-date-input">
                Date Of Birth
              </label>
              <input
                class="form-control"
                id="example-date-input"
                type="date"
                name="dob"
                [value]="
                  task?.patient && task?.patient.birthdate | date: 'yyyy-MM-dd'
                "
              />
            </div>
          </div>
        </div>

        <h2>Phone details</h2>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="mobile-number">
                Mobile Number
              </label>
              <div class="input-group input-group-merge">
                <input
                  [(ngModel)]="task?.patient.phone"
                  name="phone"
                  class="form-control"
                  placeholder="Phone number"
                  disabled
                  type="text"
                />

                <div class="input-group-append">
                  <span class="input-group-text" (click)="onCopy()">
                    <i class="ni ni-ungroup"> </i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <h2>Location</h2>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="city"> City </label>

              <select
                [value]="task?.patient.cityId"
                class="form-control"
                id="city"
                name="city"
                disabled
              >
                <option *ngFor="let city of cities" [value]="city.id">
                  {{ city.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="area"> Area </label>
              <select
                [value]="task?.patient.areaId"
                class="form-control"
                id="area"
                name="area"
                disabled
              >
                <option *ngFor="let area of areas" [value]="area.id">
                  {{ area.name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <hr />

        <h2>Physician Details</h2>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="doctor-name">
                Doctor Name
              </label>
              <input
                [(ngModel)]="task?.doctor.name"
                class="form-control"
                id="doctor-name"
                name="drName"
                [required]="!hosName.value"
                pattern="^([a-zA-Z]{2,}(\s[a-zA-Z]{2,})+)$|^([ئ يءألآلاؤآا-ى]{2,}(\s[ئ يءألآلاؤآا-ى]{2,})+)$"
                ngModel
                minlength="6"
                placeholder="Doctor Name"
                type="text"
                #drName="ngModel"
                appCheckValidity
                [appCheckValidity]="drName"
              />
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="hospital-name">
                Hospital Name
              </label>
              <input
                [(ngModel)]="task?.hospital.name"
                name="hospitalName"
                class="form-control"
                id="hospital-name"
                [required]="!drName.value"
                appCheckValidity
                [appCheckValidity]="hosName"
                ngModel
                minlength="3"
                placeholder="Hospital Name"
                type="text"
                #hosName="ngModel"
              />
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="rx"> Attach RX </label>
              <div class="input-group input-group-merge">
                <input
                  [value]="task?.rxPath"
                  class="form-control"
                  id="rx"
                  placeholder="Hospital Name"
                  disabled
                  type="text"
                />

                <div class="input-group-append">
                  <span class="view-rx input-group-text bg-transparent">
                    <a
                      class="text-primary"
                      target="_blank"
                      [href]="task?.rxPath"
                    >
                      View Rx</a
                    >
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4" *ngIf="task?.medicalReportPaths?.length > 0">
            <div class="form-group">
              <label class="form-control-label" for="patient-medical-reports">
                Medical Reports Paths
              </label>
              <button
                class="d-block btn btn-primary"
                id="patient-medical-reports"
                type="button"
                (click)="downloadMedicalReports()"
              >Download Medical Reports</button>
            </div>
          </div>
        </div>

        <div class="row psp-action-button-container mt-4">
          <div class="col btns-block">
            <button
              class="btn btn-secondary"
              type="button"
              [disabled]="!carReceiveForm.valid"
              (click)="onUpdateTask(false)"
            >
              Reject Request
            </button>
            <button
              class="btn btn-primary ml-3"
              type="button"
              [disabled]="!carReceiveForm.valid"
              (click)="onUpdateTask(true)"
            >
              Confirm
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<ngx-spinner></ngx-spinner>
